<template functional>
  <i class="fas fa-exclamation-triangle red fs15" v-if="props.item.haz_cargo" />
</template>

<script>
export default {
  name: "fltl-haz",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
